/**
 * @flow
 * @relayHash da486b6a637aa78cc5b66533ac7171db
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MarkClosedSolicitationBatchInput = {|
  ids: $ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type MarkClosedSolicitationsBatchMutationVariables = {|
  input: MarkClosedSolicitationBatchInput
|};
export type MarkClosedSolicitationsBatchMutationResponse = {|
  +markClosedSolicitationBatch: ?{|
    +isUpdated: ?boolean
  |}
|};
export type MarkClosedSolicitationsBatchMutation = {|
  variables: MarkClosedSolicitationsBatchMutationVariables,
  response: MarkClosedSolicitationsBatchMutationResponse,
|};
*/


/*
mutation MarkClosedSolicitationsBatchMutation(
  $input: MarkClosedSolicitationBatchInput!
) {
  markClosedSolicitationBatch(input: $input) {
    isUpdated
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "MarkClosedSolicitationBatchInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "markClosedSolicitationBatch",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkClosedSolicitationBatchPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isUpdated",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MarkClosedSolicitationsBatchMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "MarkClosedSolicitationsBatchMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "MarkClosedSolicitationsBatchMutation",
    "id": null,
    "text": "mutation MarkClosedSolicitationsBatchMutation(\n  $input: MarkClosedSolicitationBatchInput!\n) {\n  markClosedSolicitationBatch(input: $input) {\n    isUpdated\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bc8125b94b7ba7483e63368642bfc1a3';
module.exports = node;
